import store from "@/store"

export default function auth({ next, router }) {
    if(store?.state?.auth?.isLogged) {
        router.push('/')
        return
    }
    return next()
}
